import axios, {AxiosResponse} from 'axios'
import {
  SalesQueryResponse
} from './_models'

const BASE_URL = '/p2c/sales'

const getSales = (query: string): Promise<SalesQueryResponse> => {
  return axios
    .get(`${BASE_URL}?${query}`)
    .then((d: AxiosResponse<SalesQueryResponse>) => {
      return d.data
    })
}

export {getSales}
